const roles = {
    "Client" : "ROLE_CLIENT",
    "Admin": "ROLE_ADMIN",
    "Collaborateur" : "ROLE_COLLABORATOR"
}

export default roles; 
